/**
 * PGSS-5446 / PGSS-5447 — is the list currently showing archived records?
 *
 * An archived record is a closed book: it may be viewed, not acted on. That rule was written twice
 * and got it wrong both times.
 *
 * **The bug this replaces.** The check was `search.includes('&archive=true')` — a substring match
 * against the query string, including a leading `&`. It therefore depended on where `archive`
 * happened to sit in the URL:
 *
 *   Supplier Archived   ?sid=all&archive=true   -> matched, actions correctly hidden
 *   Customer Archived   ?archive=true&cid=all   -> NOT matched, actions wrongly shown
 *
 * Same rule, opposite outcomes, decided by the order two unrelated lines call `sp.set`. That is
 * why Supplier Archived looked correct and Customer Archived did not.
 *
 * Parsing the query string removes the positional dependence entirely.
 */
export const isArchivedView = (search) => {
  const query = typeof search === 'string' ? search : '';
  try {
    return new URLSearchParams(query).get('archive') === 'true';
  } catch {
    // A malformed query string must not decide that an archived record is editable.
    return false;
  }
};
